
export default function HeroSection() {
  const scrollToForm = () => {
    const element = document.getElementById('final-cta');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b66b4ef4ac6a5b8dd574bf360a72305c.jpg"
          alt="Hawaii Coastal Drive"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1e40af]/85 via-[#2563eb]/75 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 bg-yellow-400 text-[#1e40af] rounded-full font-semibold text-sm mb-6 shadow-lg">
            <i className="ri-star-fill mr-2"></i>
            Tour 2 Đảo & 3 Đảo - Tùy chọn linh hoạt
          </div>

          {/* Main Title */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            CARAVAN & ROADTRIP<br />
            <span className="text-yellow-400">CHINH PHỤC QUẦN ĐẢO HAWAII 2026</span>
          </h1>

          {/* Description */}
          <p className="text-xl sm:text-2xl text-white/95 mb-4 leading-relaxed">
            Hà Nội / TP.HCM → Honolulu → Waikiki → Trân Châu Cảng
          </p>
          <p className="text-lg sm:text-xl text-white/90 mb-8 leading-relaxed">
            Đảo Lớn → Núi Lửa → Maui → Hana Road
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-8">
            <button
              onClick={scrollToForm}
              className="px-8 py-4 bg-gradient-to-r from-yellow-400 to-orange-500 text-[#1e40af] rounded-full font-bold text-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line mr-2"></i>
              Đăng ký ngay
            </button>
            <a
              href="#itinerary"
              className="px-8 py-4 bg-white/20 backdrop-blur-sm text-white border-2 border-white rounded-full font-bold text-lg hover:bg-white hover:text-[#1e40af] transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
            >
              <i className="ri-file-download-line mr-2"></i>
              Tải lịch trình PDF
            </a>
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="flex items-center text-white">
              <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mr-3">
                <i className="ri-time-line text-[#1e40af] text-xl"></i>
              </div>
              <div>
                <div className="font-bold">9-10 Ngày</div>
                <div className="text-sm text-white/80">Trọn gói</div>
              </div>
            </div>
            <div className="flex items-center text-white">
              <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mr-3">
                <i className="ri-map-pin-line text-[#1e40af] text-xl"></i>
              </div>
              <div>
                <div className="font-bold">2-3 Đảo</div>
                <div className="text-sm text-white/80">Linh hoạt</div>
              </div>
            </div>
            <div className="flex items-center text-white">
              <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mr-3">
                <i className="ri-car-line text-[#1e40af] text-xl"></i>
              </div>
              <div>
                <div className="font-bold">Tự lái</div>
                <div className="text-sm text-white/80">Roadtrip</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </section>
  );
}
